import React from 'react';
import { Link } from 'react-router-dom';

const PricingPage = () => {
  const plans = [
    { name: 'Месяц', price: '2 000 ₽', period: 'в месяц', badge: null, desc: 'Гибкий старт без обязательств', btnStyle: 'outline' },
    { name: 'Квартал', price: '4 500 ₽', period: 'за 3 месяца', badge: 'Популярный', desc: 'Оптимально для быстрого запуска', btnStyle: 'fill' },
    { name: 'Год', price: '15 000 ₽', period: 'в год', badge: 'Экономия 9 000 ₽', desc: 'Максимальная выгода для бизнеса', btnStyle: 'outline' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      {/* Шапка */}
      <header style={{ padding: '20px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'white', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
          <img src="/images/10.png" alt="HR LAMA" style={{ height: '40px' }} />
          <span style={{ fontSize: '20px', fontWeight: 800, color: '#1a1a2e' }}>HR LAMA</span>
        </Link>
        <Link to="/register" style={{ padding: '10px 24px', background: 'linear-gradient(135deg, #6a11cb, #2575fc)', color: 'white', borderRadius: '50px', textDecoration: 'none', fontWeight: 600 }}>
          Начать бесплатно
        </Link>
      </header>

      <main style={{ maxWidth: '1100px', margin: '0 auto', padding: '60px 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h1 style={{ fontSize: '42px', fontWeight: 800, color: '#1a1a2e', margin: '0 0 16px' }}>Тарифы HR LAMA</h1>
          <p style={{ fontSize: '18px', color: '#64748b', maxWidth: '600px', margin: '0 auto' }}>
            Все 12 модулей включены. До 3 пользователей. 5 дней бесплатно.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', marginBottom: '60px' }}>
          {plans.map((plan, i) => (
            <div key={i} style={{
              background: 'white', borderRadius: '24px', padding: '40px 30px',
              boxShadow: plan.badge ? '0 20px 60px rgba(106, 17, 203, 0.15)' : '0 10px 30px rgba(0, 0, 0, 0.05)',
              border: plan.badge ? '2px solid #6a11cb' : '1px solid #e2e8f0',
              position: 'relative', display: 'flex', flexDirection: 'column',
            }}>
              {plan.badge && (
                <div style={{ position: 'absolute', top: '-16px', left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(135deg, #6a11cb, #2575fc)', color: 'white', padding: '8px 20px', borderRadius: '30px', fontSize: '12px', fontWeight: 700, whiteSpace: 'nowrap' }}>
                  {plan.badge}
                </div>
              )}
              <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#1a1a2e', margin: '0 0 8px' }}>{plan.name}</h2>
              <p style={{ fontSize: '14px', color: '#64748b', margin: '0 0 24px', flex: 1 }}>{plan.desc}</p>
              <div style={{ marginBottom: '32px' }}>
                <span style={{ fontSize: '42px', fontWeight: 800, color: '#6a11cb' }}>{plan.price}</span>
                <span style={{ fontSize: '14px', color: '#94a3b8', marginLeft: '8px' }}>{plan.period}</span>
              </div>
              <Link to="/register" style={{ 
                display: 'block', textAlign: 'center', padding: '16px', 
                background: plan.btnStyle === 'fill' ? 'linear-gradient(135deg, #6a11cb, #2575fc)' : '#f1f5f9',
                color: plan.btnStyle === 'fill' ? 'white' : '#6a11cb',
                borderRadius: '50px', textDecoration: 'none', fontWeight: 700, fontSize: '16px',
                transition: 'all 0.2s'
              }}>
                Начать бесплатно
              </Link>
            </div>
          ))}
        </div>

        <div style={{ background: 'white', borderRadius: '24px', padding: '40px', textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: '24px', fontWeight: 800, color: '#1a1a2e' }}>Что входит в любой тариф</h3>
          <p style={{ fontSize: '16px', color: '#475569', margin: '0 0 24px' }}>Никаких скрытых платежей. Всё необходимое для работы.</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center', fontSize: '15px', color: '#475569', fontWeight: 500 }}>
            <span>✅ Все 12 модулей</span>
            <span>✅ До 3 пользователей</span>
            <span>✅ Сервера в РФ (152-ФЗ)</span>
            <span>✅ Поддержка 24/7</span>
            <span>✅ Автоматические бэкапы</span>
          </div>
        </div>
      </main>
      
      <footer style={{ textAlign: 'center', padding: '40px', color: '#64748b', fontSize: '14px' }}>
        © 2026 HR LAMA. Все права защищены. <Link to="/" style={{ color: '#6a11cb', textDecoration: 'none', fontWeight: 600 }}>На главную</Link>
      </footer>
    </div>
  );
};

export default PricingPage;
